<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack()">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="是否审核">
              <el-select
                  placeholder="是否审核："
                  v-model="ruleForm.verify"
                  class="el-input-position"
              >
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input
                  v-model="ruleForm.name"
                  placeholder="姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机">
              <el-input
                  v-model="ruleForm.phone"
                  placeholder="手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证">
              <el-input
                  v-model="ruleForm.idCard"
                  placeholder="身份证"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱号">
              <el-input
                  v-model="ruleForm.email"
                  placeholder="邮箱号"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司">
              <el-input
                  v-model="ruleForm.company"
                  placeholder="公司"
              ></el-input>
            </el-form-item>
            <el-form-item label="职务">
              <el-input
                  v-model="ruleForm.position"
                  placeholder="职务"
              ></el-input>
            </el-form-item>
            <el-form-item label="码值">
              <el-input
                  v-model="ruleForm.code"
                  placeholder="码值"
              ></el-input>
            </el-form-item>
            <el-form-item label="团组">
              <el-input
                  v-model="ruleForm.groupNo"
                  placeholder="团组"
              ></el-input>
            </el-form-item>
            <el-form-item label="接机接站">
              <el-select placeholder="是否接机接站：" v-model="ruleForm.isReception">
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抵达方式">
              <el-input
                  v-model="ruleForm.arrivalMethod"
                  placeholder="抵达方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="抵达地点">
              <el-input
                  v-model="ruleForm.arrivalLocation"
                  placeholder="抵达地点"
              ></el-input>
            </el-form-item>
            <el-form-item label="抵达班次">
              <el-input
                  v-model="ruleForm.arrivalGrades"
                  placeholder="抵达班次"
              ></el-input>
            </el-form-item>
            <el-form-item label="抵达日期">
              <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="ruleForm.arrivalDate"
                  placeholder="抵达日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="抵达时间">
              <el-time-select
                  value-format="HH:mm"
                  :picker-options="{start: '06:00',step: '00:05',end: '23:00'}"
                  v-model="ruleForm.arrivalTime"
                  placeholder="抵达时间"
              ></el-time-select>
            </el-form-item>
            <el-form-item label="是否接到">
              <el-select placeholder="是否接到：" v-model="ruleForm.isReceived">
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="接到时间">
              <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="ruleForm.receivedTime"
                  placeholder="接到时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="接机人">
              <el-input
                  v-model="ruleForm.receivedName"
                  placeholder="接机人"
              ></el-input>
            </el-form-item>
            <el-form-item label="接机人手机">
              <el-input
                  v-model="ruleForm.receivedPhone"
                  placeholder="接机人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="接机人车牌">
              <el-input
                  v-model="ruleForm.receivedCarNo"
                  placeholder="接机人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="接机车型">
              <el-input
                  v-model="ruleForm.receivedCar"
                  placeholder="接机车型"
              ></el-input>
            </el-form-item>
            <el-form-item label="接机车型">
              <el-input
                  v-model="ruleForm.receivedCar"
                  placeholder="接机车型"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机送站">
              <el-select placeholder="是否送机送站：" v-model="ruleForm.isGive">
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送机日期">
              <el-date-picker
                  v-model="ruleForm.giveDate"
                  type="datetime"
                  width="100"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="送机时间">
              <el-time-select
                  :picker-options="{start: '06:00',step: '00:05',end: '23:00'}"
                  value-format="HH:mm"
                  v-model="ruleForm.giveTime"
                  placeholder="送机时间"
              ></el-time-select>
            </el-form-item>
            <el-form-item label="送机方式">
              <el-input
                  v-model="ruleForm.giveMethod"
                  placeholder="送机方式送机方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机地点">
              <el-input
                  v-model="ruleForm.giveLocation"
                  placeholder="送机地点"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机班次">
              <el-input
                  v-model="ruleForm.giveGrades"
                  placeholder="送机班次"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机人">
              <el-input
                  v-model="ruleForm.giveName"
                  placeholder="送机人"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机人手机">
              <el-input
                  v-model="ruleForm.givePhone"
                  placeholder="送机人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机人车型">
              <el-input
                  v-model="ruleForm.giveCar"
                  placeholder="送机人车型"
              ></el-input>
            </el-form-item>
            <el-form-item label="送机人车牌">
              <el-input
                  v-model="ruleForm.giveCarNo"
                  placeholder="送机人车牌"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否送达">
              <el-select
                  placeholder="是否送达："
                  clearable
                  v-model="ruleForm.isDelivery"
                  class="el-input-position"
              >
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送达时间">
              <el-date-picker
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="ruleForm.deliveryTime"
                  placeholder="送达时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="入住酒店">
              <el-select
                  placeholder="是否入住酒店："
                  v-model="ruleForm.isCheckIn"
                  class="el-input-position"
              >
                <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="酒店名称">
              <el-input
                  v-model="ruleForm.hotel"
                  placeholder="酒店名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="房间类型">
              <el-input
                  v-model="ruleForm.roomType"
                  placeholder="团组"
              ></el-input>
            </el-form-item>
            <el-form-item label="房间号">
              <el-input
                  v-model="ruleForm.roomNo"
                  placeholder="团组"
              ></el-input>
            </el-form-item>
            <el-form-item label="入住酒店时间">
              <el-date-picker
                  v-model="ruleForm.checkInTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="离开酒店时间">
              <el-date-picker
                  v-model="ruleForm.departureTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../public/UploadImg";
import checkPhone from "../common/checkPhone";

export default {
  name: "editexhibiorspersonal",
  data() {
    return {
      projectId: localStorage.getItem("project_Id"),
      rules: {
        // documentTypeId: [
        //   {required: true, message: "证件类型不能为空", trigger: "blur"},
        // ],
        // disabled: [{required: true, message: "禁用状态不能为空", trigger: "blur"}],
        // verify: [{required: true, message: "审核状态不能为空", trigger: "blur"}],
        // name: [{required: true, message: "姓名不能为空", trigger: "blur"}],
        // registerId: [{required: true, message: "注册通道不能为空", trigger: "blur"}],
        // type: [{required: true, message: "请选择类型", trigger: "blur"}],
        // position: [{required: false, message: "职务不能为空", trigger: "blur"}],
        //phone: [{ required: false, validator: checkPhone, trigger: "blur" }],
      },
      options: [{name: '是', value: 1}, {name: '否', value: 0}],
      ruleForm: {
        roomType: "",
        hotel: "",
        roomNo: "",
        name: "",
        phone: "",
        code: "",
        position: "",
        email: "",
        idCard: "",
        verify: 0,
        isReception: 0,
        isReceived: 0,
        isCheckIn: 0,
        isGive: 0,
        isDelivery: 0,
        company: "",
        groupNo: "",
        deliveryTime: "",
        receivedTime: "",
        arrivalGrades: "",
        arrivalDate: "",
        receivedName: "",
        receivedPhone: "",
        receivedCarNo: "",
        receivedCar: "",
        giveTime: "",
        arrivalTime: "",
        arrivalLocation: "",
        giveLocation: "",
        checkInTime: "",
        giveDate: "",
        giveMethod: "",
        giveGrades: "",
        giveName: "",
        givePhone: "",
        giveCar: "",
        giveCarNo: "",
        arrivalMethod: "",
        departureTime: "",
      },
      receptionId: "",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  created() {
    this.loadData();
  },
  watch: {
    $route: "getPath",
    editData: function () {
      const item = this.editData;
      if (item) {
        this.ruleForm = this.editData;
        this.receptionId = item.receptionId;
      }
    },
  },
  methods: {
    select(item) {
      this.ruleForm.groupNo = item.name
    },
    handleChange(e) {
      this.ruleForm.groupNo = '';
      this.groupUsers.forEach(item => {
        if (item.groupUserId == e) {
          this.ruleForm.groupNo = item.name
          return;
        }
      })
    },
    loadData() {
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.receptionId == "" || this.receptionId == undefined) {
            this.$axios.post("/Reception/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Reception/" + this.receptionId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {
                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.receptionId = "";
      this.ruleForm.avatar = "";
      this.$refs.ruleForm.resetFields();
    },
  },
  components: {
    UploadImg,
  },
};
</script>